import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useAuth } from '@/composables/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppleRelayEmailNotice',
  setup(__props) {

const APPLE_PRIVATE_RELAY_DOMAIN = '@privaterelay.appleid.com'

const { user } = useAuth()

const userEmail = computed(() => user.value?.email ?? '')

const isAppleRelayEmail = computed(() =>
  userEmail.value.includes(APPLE_PRIVATE_RELAY_DOMAIN)
)

return { __sfc: true,APPLE_PRIVATE_RELAY_DOMAIN, user, userEmail, isAppleRelayEmail }
}

})